import { generatePath, Route } from 'react-router-dom';

import { GuardRoute } from 'modules/auth';
import { createRouteConfig } from 'modules/common';

import { CreateTask } from './screens/CreateTask';
import { EditTask } from './screens/EditTask';

const BASE_PATH = `/task`;
const CREATE_TASK_PATH = `${BASE_PATH}/create`;

export const TaskRoutesConfig = createRouteConfig(
  {
    createTask: {
      path: CREATE_TASK_PATH,
      generatePath: () => generatePath(CREATE_TASK_PATH),
    },
    editTask: {
      path: BASE_PATH,
      generatePath: (taskId: string, chainUnit: string) =>
        `${generatePath(BASE_PATH)}/?taskId=${taskId}&network=${chainUnit}`,
    },
  },
  BASE_PATH,
);

export function getTaskRoutes(): JSX.Element {
  return (
    <>
      <Route
        path={TaskRoutesConfig.createTask.path}
        element={
          <GuardRoute>
            <CreateTask />
          </GuardRoute>
        }
      />

      <Route
        path={TaskRoutesConfig.editTask.path}
        element={
          <GuardRoute>
            <EditTask />
          </GuardRoute>
        }
      />
    </>
  );
}
